import TabLink from './TabLink.vue'
import TabPane from './TabPane.vue'
import Tabs from './Tabs.vue'

export { TabLink, TabPane, Tabs }
